<template>
  <div class="d-inline-block">
    <v-chip slot="activator"
      text-color="white"
      :color="`${active ? 'primary' : 'grey'} darken-2`"
      @click="$emit('selected', { id: entitlement, actions })"
    >
      <strong class="body-2 white primary--text text--darken-2 px-2 rounded">{{ entitlement }}</strong>
      <span class="mx-2">{{ actions.join(' - ') }}</span>
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'EntitlementsList',
  props: {
    /**
     * Entitlement name
     */
    entitlement: {
      type: String,
      required: true
    },
    /**
     * Entitlement actions
     */
    actions: {
      type: Array,
      required: true
    },
    /**
     * Active state
     */
    active: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
